import {Injectable} from '@angular/core';
import * as componentActions from '@catdetails/actions/upload-files';
import {Store} from '@ngrx/store';
import {RestHttpService} from "@catcore/services/rest-http.service";
import {Restangular} from "ngx-restangular";
import {Observable} from "rxjs";
import {FileDownloadInfo} from "@catcore/types/common";
import {HttpClient, HttpResponse} from "@angular/common/http";
import {FileBlobResponse} from "@catcore/utils";

@Injectable()
export class UploadFilesService extends RestHttpService<any> {
  constructor(private http: HttpClient,
              private service: Restangular,
              private store: Store<any>) {
    super('upload-files', service);
  }

  setActive() {
    this.store.dispatch({
        type: componentActions.PROJECT_DETAILS_USR_ACTIVATE,
      },
    );
  }

  setInactive() {
    this.store.dispatch({
        type: componentActions.PROJECT_DETAILS_USR_DEACTIVATE,
      },
    );
  }

  downloadFile(url): Observable<any> {
    return this.fileDownload(url);
  }

  private fileDownload(url): Observable<FileDownloadInfo> {
    return this.http
      .get(url, {responseType: 'blob', observe: 'response'})
      .map((response: HttpResponse<Blob>) => {
        const fileResponse = new FileBlobResponse(response);
        return {blob: fileResponse.body, filename: fileResponse.filename};
      });
  }

  delete(id) {
    return super.delete({
      _links: {
        self: {
          href: 'upload-files/' + id
        }
      }
    })
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/project-details/services/upload-files.service.ts